package org.hs_soft.runmynesto.data.api_datasource.authentication

import androidx.compose.runtime.NoLiveLiterals
import org.hs_soft.runmynesto.domain.repository.network_datasource.login.SignInRepository
import org.hs_soft.runmynesto.domain.util.jsObject
import org.hs_soft.runmynesto.modules.Auth


class SignInRepositoryImpl:SignInRepository{

    @NoLiveLiterals
    override fun signIn(
        userName: String,
        password: String,
        mfaCode: String,
        isSecondStep:Boolean,
        goToSecondStep:()->Unit,
        onSuccess: () -> Unit,
        onError:(String)->Unit,
    ) {

        val options = jsObject<Any> {
            this["username"] = userName
            this["password"] = password
        }
        Auth.signIn(options).then { result ->
            if (result.isSignedIn == false) {
                if (isSecondStep){
                    confirmTOTP(
                        user = result,
                        totpCode = mfaCode,
                        onSuccess = {
                            onSuccess()
                        },
                        onError={
                            onError(it)
                        }
                    )
                }
                goToSecondStep()

            }else if(result.isSignedIn==true){
                onSuccess()
            }

        }.catch { error: dynamic ->
            onError(error.toString())
        }
    }


}

@NoLiveLiterals
private fun confirmTOTP(
    user: dynamic,
    totpCode: String,
    onSuccess: () -> Unit,
    onError: (String) -> Unit,
) {
    console.log(Auth.confirmSignIn)

    val input = jsObject<Any> {
        this["challengeResponse"] = totpCode
        this["options"] = jsObject<Any> {
            this["username"] = user.username
            this["challengeName"] = user.challengeName
            this["signInSession"] = user.signInSession
            this["signInDetails"] = user.signInDetails
        }
    }
    Auth.confirmSignIn(input).then { result ->
        onSuccess()
        console.log(result)
    }.catch { error: dynamic ->
        onError(error.toString())
        console.log("TOTP confirmation error: ${error}")
    }
}
